import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useMutation } from '@tanstack/react-query'
import type { ReferralActionResponse, ReferralTrackClick } from 'types/api'
import { BaseParams } from 'types/utils'

export function useTrackReferralClick() {
  async function trackReferralClick({
    body
  }: BaseParams<ReferralTrackClick, 'POST'>) {
    const response = await apiClient.post<ReferralActionResponse>(
      `${SNA_PREFIX}referrals/track-click`,
      body
    )
    return response.data
  }

  return useMutation({
    mutationFn: trackReferralClick
  })
}
